import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";
import { FilterParameterModel } from "../filter-parameters/models/filter-parameter.model";
import { PanelParameterModel } from "./models/panel-parameter.model";

export class ParametersPanelComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR: string = ".js-ina-parameters-panel";

    private _currentContext: JQuery = $();

    private _parameters: Array<PanelParameterModel> = [];

    public syncParameters(filterParameter: FilterParameterModel): void {
        const name = filterParameter.name;
        let panelParameter: PanelParameterModel = this._parameters.find(x => x.name === name);
        if (!panelParameter) {
            panelParameter = {
                name: name,
                sortOrder: filterParameter.sortOrder,
                values: []
            };

            this._parameters.push(panelParameter);
            this._parameters = this._parameters.sort((a, b) => a.sortOrder - b.sortOrder);
        }

        const valuesArray = Array.isArray(filterParameter.value) ? filterParameter.value : filterParameter.value.data === "" ? [] : [filterParameter.value];

        // insert values
        const valuesToInsert = valuesArray.filter(v => panelParameter.values.findIndex(p => p.data === v.data) === -1);

        valuesToInsert.forEach(value => {
            panelParameter.values.push({
                data: value.data,
                sortOrder: value.sortOrder,
                element: this.createParameterElement(name, value.name, value.data)
            });
        });

        panelParameter.values = panelParameter.values.sort((a, b) => a.sortOrder - b.sortOrder);

        let index = 0;
        this._parameters.forEach(parameter => {
            parameter.values.forEach(value => {
                const $child = this._currentContext.children().eq(index);
                if ($child !== value.element) {
                    $child.before(value.element);
                }
                index++;
            });
        });

        // remove values
        const valuesToRemove = panelParameter.values.filter(p => valuesArray.findIndex(v => v.data === p.data) === -1);

        valuesToRemove.forEach(param => {
            param.element.remove();

            const paramIndex = panelParameter.values.indexOf(param);
            if (paramIndex > -1) {
                panelParameter.values.splice(paramIndex, 1);
            }
        });
    }

    private createParameterElement(group: string, name: string, value: string): JQuery {
        const nameElement = $.el("span");
        nameElement.text(name);
        const button = $.el("button", { class: "ina-filter__close-btn", type: "button" });
        button.on("click", e => {
            e.preventDefault();
            this.emit("params/remove", {
                group: group,
                value: value
            });
        });

        const param = $.el("li", { class: "ina-filter__item" }).append(nameElement, button);

        return param;
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;
    }
}
